// Package imports:
import React from 'react';
// Component imports:
import ColoredNumber, { BackgroundSign, Sign } from '../ColoredNumber/ColoredNumber';

interface IProps {
    hasArrow?: boolean,
    hasBackground?: boolean,
    hasColor?: boolean,
    currentValue: number | null,
    previousValue: number | null
}

const CalculatedColoredNumber: React.FC<IProps>= ({
    children,
    currentValue,
    previousValue,
    hasArrow,
    hasBackground,
    hasColor
}) => {
    const sign: Sign = (currentValue === null)
        ? 'neutral'
        : (currentValue > 0)
        ? 'pos'
        : (currentValue < 0)
        ? 'neg'
        : 'neutral';
    const backgroundSign: BackgroundSign | undefined = (previousValue === null || currentValue === null)
        ? undefined
        : (currentValue > previousValue)
        ? 'pos'
        : (currentValue < previousValue)
        ? 'neg'
        : undefined;
    
    return (
        <ColoredNumber
            sign={hasColor ? sign : undefined}
            background={hasBackground ? backgroundSign : undefined}
            hasArrow={hasArrow}
        >
            {children}
        </ColoredNumber>
    );
}

export default CalculatedColoredNumber;